import React from 'react';
import ReactDOM from 'react-dom';
import {App} from '../../js/app';
import {LoginController} from '../../js/login/login_controller.jsx';

const element = document.getElementById('login');
ReactDOM.render(
  <React.StrictMode>
    <App>
      <LoginController />
    </App>
  </React.StrictMode>,
  element
);
